module.exports = __webpack_public_path__ + "img/22ne.14635111.svg";